import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// Инициализация i18next
i18n.use(Backend) // Загрузка переводов из JSON-файлов (по умолчанию урл public/locales/{lang})
    .use(initReactI18next) // Интеграция с React
    .use(LanguageDetector) // Определение языка браузера
    .init({
        fallbackLng: 'ru', // Язык по умолчанию
        debug: false, // Логирование в консоли
        interpolation: {
            escapeValue: false, // экранирование уже есть в React, поэтому отключаем
        },
        supportedLngs: ['ru', 'en'],
        nsSeparator: false, // подгружает только те json файлики, который необходимы для текущего языка
        ns: [
            'header',
            'commonInfo',
            'npvAnalytics',
            'wordsDeclension',
            'ratesAndPrices',
            'projects',
            'supervising',
            'mainPage',
            'supervConstUtils',
            'tables',
            'monitoring',
            'administration',
            'drillBitAnalytics',
            'resources',
            'chiselPrograms',
            'drillingCarpet',
        ], // Указываем доступные пространства имен (названия файлов)
        defaultNS: 'common', // Пространство имен по умолчанию
        fallbackNS: 'common', // Если нет перевода в ns, берёт из common
        react: {
            useSuspense: false,
            // Переводы грузятся с сервера, а при смене языка страница перезагружается.
            // Suspense не нужен, чтобы не ловить ошибки во время загрузки.
        },
    });

export default i18n;
